export default __webpack_public_path__ + "static/media/profile-bg.8129069f.jpg";